import { render, staticRenderFns } from "./modalTranslateQuestion.vue?vue&type=template&id=21e4e66b&"
import script from "./modalTranslateQuestion.vue?vue&type=script&lang=js&"
export * from "./modalTranslateQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports